import { render, staticRenderFns } from "./NewReward.vue?vue&type=template&id=26130e08&scoped=true"
import script from "./NewReward.vue?vue&type=script&lang=js"
export * from "./NewReward.vue?vue&type=script&lang=js"
import style0 from "./NewReward.vue?vue&type=style&index=0&id=26130e08&prod&scoped=true&lang=css"
import style1 from "./NewReward.vue?vue&type=style&index=1&id=26130e08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26130e08",
  null
  
)

export default component.exports